import styled, { css } from 'react-emotion'

export const justifyContent = css`
justify-content: center`

export const reminderStyle = css`
  display: flex;
  // margin-top: .9rem;
  position: relative;
  .large {
    width: 2.1rem !important;
    height: 2.1rem !important;
  }
  .animate_icon {
    filter: none;
    transition: transform .3s;
    transform: rotate(45deg);
  }
  .animate_icon_inactive {
    filter: none !important;
    // transition: transform .3s;
    // transform: rotate(45deg);
    brightness(0.1) invert(0.8);
  }
  .show_tooltip {
    transition: all .3s;
    visibility: visible !important;
  }
  .animate_icon_mobile {
    animation: shake .3s 1 alternate ease-in-out;
  }
  @keyframes shake {
    50% {
      transform: rotate(45deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  :hover {
    cursor: pointer;
    // .reminder-icon {
    //   filter: none;
    //   transition: transform .3s;
    //   transform: rotate(45deg);
    // }
    // .reminder-icon-active {
    //   transition: all .3s;
    //   transform: rotate(45deg);
    // }
    // .tooltip {
    //   transition: all .3s;
    //   visibility: visible;
    // }
    .reminder-text {
      transition: all .3s;
      color: #FFFFFF;
    }
  }
  @media (hover: none) {
    .tooltip {
      visibility: hidden !important;
    }
    .reminder-icon {
      filter: brightness(0.1) invert(0.8) !important;
      transition: none !important;
      transform: none !important;
    }
    .reminder-icon-active {
      transition: none !important;
      transform: none !important;
    }
    .reminder-text {
      transition: none !important;
      color: #C1C2C2 !important;
    }
  }
  .tooltip {
    visibility: hidden;
    background: #5E7D9F;
    width: 8rem;
    height: 2.6rem;
    position: absolute;
    border-radius: 4px;
    top: -3rem;
    left: -3rem;
    display: flex;
    &-text {
      display: flex;
      psoition: relative;
      justify-content: center;
      align-self: center;
      margin: auto;
    }
    .arrow {
      width: 0; 
      height: 0; 
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid #5E7D9F;
      position: absolute;
      bottom: -.3rem;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
  .reminder-icon {
    transition: transform .3s;
    width: 1.5rem;
    height: 1.5rem;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02Ljc1MTkyIDIuMTk1NTlDNS4zNzk5NCAyLjYzODAxIDQuMzA3NzggMy43OTI3MyA0LjAxMjYyIDUuMjY4NTJMMi44NzA3IDEwLjk3ODFDMi44Mjk0IDExLjE4NDYgMi42NDgwOSAxMS4zMzMzIDIuNDM3NDkgMTEuMzMzM0gxLjY2NjM0QzEuNDgyMjUgMTEuMzMzMyAxLjMzMzAxIDExLjQ4MjUgMS4zMzMwMSAxMS42NjY2QzEuMzMzMDEgMTEuODUwNyAxLjQ4MjI1IDExLjk5OTkgMS42NjYzNCAxMS45OTk5SDIuNjY2MzRIMTMuMzMzSDE0LjMzM0MxNC41MTcxIDExLjk5OTkgMTQuNjY2MyAxMS44NTA3IDE0LjY2NjMgMTEuNjY2NkMxNC42NjYzIDExLjQ4MjUgMTQuNTE3MSAxMS4zMzMzIDE0LjMzMyAxMS4zMzMzSDEzLjU2MTlDMTMuMzUxMyAxMS4zMzMzIDEzLjE2OTkgMTEuMTg0NiAxMy4xMjg2IDEwLjk3ODFMMTEuOTg2NyA1LjI2ODUyQzExLjY5MTYgMy43OTI3MyAxMC42MTk0IDIuNjM4MDEgOS4yNDc0MyAyLjE5NTU5QzkuMDU3MTEgMS42OTE2NCA4LjU3MDI1IDEuMzMzMjUgNy45OTk2NyAxLjMzMzI1QzcuNDI5MSAxLjMzMzI1IDYuOTQyMjQgMS42OTE2NCA2Ljc1MTkyIDIuMTk1NTlaTTcuOTk5NjcgMi42NjY1OUM2LjM3OTI3IDIuNjY2NTkgNC45ODQxMyAzLjgxMDMzIDQuNjY2MzQgNS4zOTkyN0wzLjU1OTI5IDEwLjkzNDVDMy41MTgwMyAxMS4xNDA4IDMuNjc1OCAxMS4zMzMzIDMuODg2MTUgMTEuMzMzM0gxMi4xMTMyQzEyLjMyMzYgMTEuMzMzMyAxMi40ODEzIDExLjE0MDggMTIuNDQwMSAxMC45MzQ1TDExLjMzMyA1LjM5OTI2QzExLjAxNTIgMy44MTAzMyA5LjYyMDA4IDIuNjY2NTkgNy45OTk2NyAyLjY2NjU5Wk01LjY4OTc2IDEzLjMzMzNDNi4xNTA4NCAxNC4xMzAzIDcuMDEyNjMgMTQuNjY2NiA3Ljk5OTY3IDE0LjY2NjZDOC45ODY3MiAxNC42NjY2IDkuODQ4NTEgMTQuMTMwMyAxMC4zMDk2IDEzLjMzMzNINS42ODk3NloiIGZpbGw9IiMxRjkzRkYiLz4KPC9zdmc+Cg==");
    // background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01Ljc1MjQgMS4xOTU1OUM0LjM4MDQzIDEuNjM4MDEgMy4zMDgyNyAyLjc5MjczIDMuMDEzMTEgNC4yNjg1MkwxLjg3MTE5IDkuOTc4MUMxLjgyOTg5IDEwLjE4NDYgMS42NDg1NyAxMC4zMzMzIDEuNDM3OTggMTAuMzMzM0gwLjY2NjgyOUMwLjQ4MjczNSAxMC4zMzMzIDAuMzMzNDk2IDEwLjQ4MjUgMC4zMzM0OTYgMTAuNjY2NkMwLjMzMzQ5NiAxMC44NTA3IDAuNDgyNzM1IDEwLjk5OTkgMC42NjY4MjkgMTAuOTk5OUgxLjY2NjgzSDEyLjMzMzVIMTMuMzMzNUMxMy41MTc2IDEwLjk5OTkgMTMuNjY2OCAxMC44NTA3IDEzLjY2NjggMTAuNjY2NkMxMy42NjY4IDEwLjQ4MjUgMTMuNTE3NiAxMC4zMzMzIDEzLjMzMzUgMTAuMzMzM0gxMi41NjIzQzEyLjM1MTggMTAuMzMzMyAxMi4xNzA0IDEwLjE4NDYgMTIuMTI5MSA5Ljk3ODFMMTAuOTg3MiA0LjI2ODUyQzEwLjY5MjEgMi43OTI3MyA5LjYxOTg5IDEuNjM4MDEgOC4yNDc5MiAxLjE5NTU5QzguMDU3NiAwLjY5MTY0MiA3LjU3MDczIDAuMzMzMjUyIDcuMDAwMTYgMC4zMzMyNTJDNi40Mjk1OSAwLjMzMzI1MiA1Ljk0MjczIDAuNjkxNjQyIDUuNzUyNCAxLjE5NTU5Wk03LjAwMDE2IDEuNjY2NTlDNS4zNzk3NiAxLjY2NjU5IDMuOTg0NjIgMi44MTAzMyAzLjY2NjgzIDQuMzk5MjdMMi41NTk3NyA5LjkzNDU1QzIuNTE4NTIgMTAuMTQwOCAyLjY3NjI4IDEwLjMzMzMgMi44ODY2MyAxMC4zMzMzSDExLjExMzdDMTEuMzI0IDEwLjMzMzMgMTEuNDgxOCAxMC4xNDA4IDExLjQ0MDYgOS45MzQ1NUwxMC4zMzM1IDQuMzk5MjZDMTAuMDE1NyAyLjgxMDMzIDguNjIwNTcgMS42NjY1OSA3LjAwMDE2IDEuNjY2NTlaTTQuNjkwMjUgMTIuMzMzM0M1LjE1MTMzIDEzLjEzMDMgNi4wMTMxMiAxMy42NjY2IDcuMDAwMTYgMTMuNjY2NkM3Ljk4NzIxIDEzLjY2NjYgOC44NDkgMTMuMTMwMyA5LjMxMDA4IDEyLjMzMzNINC42OTAyNVoiIGZpbGw9IiNDMUMyQzIiLz4KPC9zdmc+Cg==");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    filter: brightness(0.1) invert(0.8);
  }
  .reminder-icon-active {
    transition: all .3s;
    width: 1.5rem;
    height: 1.5rem;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjAxMjg2IDQuMjY4NjRDMy4zMDgwMiAyLjc5Mjg1IDQuMzgwMTkgMS42MzgxNCA1Ljc1MjE2IDEuMTk1NzFDNS45NDI0OCAwLjY5MTc2NCA2LjQyOTM1IDAuMzMzMzc0IDYuOTk5OTIgMC4zMzMzNzRDNy41NzA0OSAwLjMzMzM3NCA4LjA1NzM1IDAuNjkxNzY0IDguMjQ3NjggMS4xOTU3MUM5LjYxOTY1IDEuNjM4MTMgMTAuNjkxOCAyLjc5Mjg1IDEwLjk4NyA0LjI2ODY0TDEyLjEyODkgOS45NzgyMkMxMi4xNzAyIDEwLjE4NDcgMTIuMzUxNSAxMC4zMzM0IDEyLjU2MjEgMTAuMzMzNEgxMy4zMzMzQzEzLjUxNzMgMTAuMzMzNCAxMy42NjY2IDEwLjQ4MjYgMTMuNjY2NiAxMC42NjY3QzEzLjY2NjYgMTAuODUwOCAxMy41MTczIDExIDEzLjMzMzMgMTFIMTIuMzMzM0gxLjY2NjU5SDAuNjY2NTg1QzAuNDgyNDkgMTEgMC4zMzMyNTIgMTAuODUwOCAwLjMzMzI1MiAxMC42NjY3QzAuMzMzMjUyIDEwLjQ4MjYgMC40ODI0OSAxMC4zMzM0IDAuNjY2NTg1IDEwLjMzMzRIMS40Mzc3M0MxLjY0ODMzIDEwLjMzMzQgMS44Mjk2NSAxMC4xODQ3IDEuODcwOTUgOS45NzgyMkwzLjAxMjg2IDQuMjY4NjRaTTYuOTk5OTIgMTMuNjY2N0M2LjAxMjg4IDEzLjY2NjcgNS4xNTEwOCAxMy4xMzA0IDQuNjkgMTIuMzMzNEg5LjMwOTgzQzguODQ4NzUgMTMuMTMwNCA3Ljk4Njk2IDEzLjY2NjcgNi45OTk5MiAxMy42NjY3WiIgZmlsbD0iIzFGOTNGRiIvPgo8L3N2Zz4K");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
  .reminder-text {
    font-family: Public Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 1.2rem;
    line-height: 1.16;
    color: #C1C2C2;
    margin-left: .5rem;
    display: flex;
    align-self: center;
  }
  .reminder-text-active {
    font-family: Public Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 1.2rem;
    line-height: 1.16;
    color: #1F93FF;
    margin-left: .5rem;
    display: flex;
    align-self: center;
  }
`

export const loaderStyle = css`
  display: flex;
  justify-content: start;
  height: 2.5rem;
  .lds-ring {
    display: inline-block;
    position: relative;
    transform: scale(0.2);
    width: 1rem;
    height: 1rem;
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 4px solid #1F93FF;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1F93FF transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export const countDownStyle = css`
  .divider-text {
    font-family: Public Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 1.4rem;
    line-height: 1.6rem;    
    color: #838586;
    margin-top: 1.6rem;
    margin-bottom: 1.6rem;
  }
  .reminder-gtp {
    font-family: Public Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 1.4rem;
    line-height: 1.6rem;
    text-decoration-line: underline;
    color: #C1C2C2;

    :hover {
      cursor: pointer;
      color: #1f93ff;
    }
  }
`
export const reminderOptionStyle = css`
  .reminder-divider-text {
    font-family: Public Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #838586;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .reminder-gtp-text {
    font-family: Public Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    text-decoration-line: underline;
    color: #C1C2C2;
    :hover {
      cursor: pointer;
      color: #1f93ff;
    }
  }
`

export const reminderMobileDetail = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 5.5rem;
  margin-top: 20px;
  .animate_icon_mobile {
    animation: shake .3s 1 alternate ease-in-out;
  }
  @keyframes shake {
    50% {
      transform: rotate(45deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  :hover {
    cursor: pointer;
    .reminder-icon {
      transition: all .3s;
      transform: rotate(45deg);
    }
    .reminder-icon-active {
      transition: all .3s;
      transform: rotate(45deg);
    }
  }
  @media (hover: none) {
    .reminder-icon {
      transition: none !important;
      transform: none !important;
    }
    .reminder-icon-active {
      transition: none !important;
      transform: none !important;
    }
  }
  .reminder-icon {
    width: 1.8rem;
    height: 1.8rem;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01Ljc1MjQgMS4xOTU1OUM0LjM4MDQzIDEuNjM4MDEgMy4zMDgyNyAyLjc5MjczIDMuMDEzMTEgNC4yNjg1MkwxLjg3MTE5IDkuOTc4MUMxLjgyOTg5IDEwLjE4NDYgMS42NDg1NyAxMC4zMzMzIDEuNDM3OTggMTAuMzMzM0gwLjY2NjgyOUMwLjQ4MjczNSAxMC4zMzMzIDAuMzMzNDk2IDEwLjQ4MjUgMC4zMzM0OTYgMTAuNjY2NkMwLjMzMzQ5NiAxMC44NTA3IDAuNDgyNzM1IDEwLjk5OTkgMC42NjY4MjkgMTAuOTk5OUgxLjY2NjgzSDEyLjMzMzVIMTMuMzMzNUMxMy41MTc2IDEwLjk5OTkgMTMuNjY2OCAxMC44NTA3IDEzLjY2NjggMTAuNjY2NkMxMy42NjY4IDEwLjQ4MjUgMTMuNTE3NiAxMC4zMzMzIDEzLjMzMzUgMTAuMzMzM0gxMi41NjIzQzEyLjM1MTggMTAuMzMzMyAxMi4xNzA0IDEwLjE4NDYgMTIuMTI5MSA5Ljk3ODFMMTAuOTg3MiA0LjI2ODUyQzEwLjY5MjEgMi43OTI3MyA5LjYxOTg5IDEuNjM4MDEgOC4yNDc5MiAxLjE5NTU5QzguMDU3NiAwLjY5MTY0MiA3LjU3MDczIDAuMzMzMjUyIDcuMDAwMTYgMC4zMzMyNTJDNi40Mjk1OSAwLjMzMzI1MiA1Ljk0MjczIDAuNjkxNjQyIDUuNzUyNCAxLjE5NTU5Wk03LjAwMDE2IDEuNjY2NTlDNS4zNzk3NiAxLjY2NjU5IDMuOTg0NjIgMi44MTAzMyAzLjY2NjgzIDQuMzk5MjdMMi41NTk3NyA5LjkzNDU1QzIuNTE4NTIgMTAuMTQwOCAyLjY3NjI4IDEwLjMzMzMgMi44ODY2MyAxMC4zMzMzSDExLjExMzdDMTEuMzI0IDEwLjMzMzMgMTEuNDgxOCAxMC4xNDA4IDExLjQ0MDYgOS45MzQ1NUwxMC4zMzM1IDQuMzk5MjZDMTAuMDE1NyAyLjgxMDMzIDguNjIwNTcgMS42NjY1OSA3LjAwMDE2IDEuNjY2NTlaTTQuNjkwMjUgMTIuMzMzM0M1LjE1MTMzIDEzLjEzMDMgNi4wMTMxMiAxMy42NjY2IDcuMDAwMTYgMTMuNjY2NkM3Ljk4NzIxIDEzLjY2NjYgOC44NDkgMTMuMTMwMyA5LjMxMDA4IDEyLjMzMzNINC42OTAyNVoiIGZpbGw9IiNDMUMyQzIiLz4KPC9zdmc+Cg==");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
  .reminder-icon-active {
    width: 1.8rem;
    height: 1.8rem;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjAxMjg2IDQuMjY4NjRDMy4zMDgwMiAyLjc5Mjg1IDQuMzgwMTkgMS42MzgxNCA1Ljc1MjE2IDEuMTk1NzFDNS45NDI0OCAwLjY5MTc2NCA2LjQyOTM1IDAuMzMzMzc0IDYuOTk5OTIgMC4zMzMzNzRDNy41NzA0OSAwLjMzMzM3NCA4LjA1NzM1IDAuNjkxNzY0IDguMjQ3NjggMS4xOTU3MUM5LjYxOTY1IDEuNjM4MTMgMTAuNjkxOCAyLjc5Mjg1IDEwLjk4NyA0LjI2ODY0TDEyLjEyODkgOS45NzgyMkMxMi4xNzAyIDEwLjE4NDcgMTIuMzUxNSAxMC4zMzM0IDEyLjU2MjEgMTAuMzMzNEgxMy4zMzMzQzEzLjUxNzMgMTAuMzMzNCAxMy42NjY2IDEwLjQ4MjYgMTMuNjY2NiAxMC42NjY3QzEzLjY2NjYgMTAuODUwOCAxMy41MTczIDExIDEzLjMzMzMgMTFIMTIuMzMzM0gxLjY2NjU5SDAuNjY2NTg1QzAuNDgyNDkgMTEgMC4zMzMyNTIgMTAuODUwOCAwLjMzMzI1MiAxMC42NjY3QzAuMzMzMjUyIDEwLjQ4MjYgMC40ODI0OSAxMC4zMzM0IDAuNjY2NTg1IDEwLjMzMzRIMS40Mzc3M0MxLjY0ODMzIDEwLjMzMzQgMS44Mjk2NSAxMC4xODQ3IDEuODcwOTUgOS45NzgyMkwzLjAxMjg2IDQuMjY4NjRaTTYuOTk5OTIgMTMuNjY2N0M2LjAxMjg4IDEzLjY2NjcgNS4xNTEwOCAxMy4xMzA0IDQuNjkgMTIuMzMzNEg5LjMwOTgzQzguODQ4NzUgMTMuMTMwNCA3Ljk4Njk2IDEzLjY2NjcgNi45OTk5MiAxMy42NjY3WiIgZmlsbD0iIzFGOTNGRiIvPgo8L3N2Zz4K");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
  .reminder-text {
    font-family: Public Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 1.2rem;
    line-height: 1.16;
    color: #C1C2C2;
    margin-top: 1rem;
  }
  .reminder-text-active {
    font-family: Public Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 1.2rem;
    line-height: 1.16;
    color: #1F93FF;
    margin-top: 1rem;
  }
`